import React from "react";
import { FlatButton, TextField, Checkbox } from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import VirtualContentStore from "../../../stores/VirtualContentStore";
import VirtualContentActions from "../../../actions/VirtualContentActions";

import BaseOverlay from "./base.jsx";

class AddExternalVirtualContentOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      url: "",
      permission: false
    };

    this.submit = this.submit.bind(this);
  }

  static getStores() {
    return [VirtualContentStore];
  }

  static getPropsFromStores() {
    return VirtualContentStore.getState();
  }

  submit() {
    this.setState({ submitting: true });
    VirtualContentActions.create({
      type: "external",
      egress_url: this.state.url
    });
  }

  componentWillReceiveProps(newProps) {
    if (this.props.isCreating && newProps.newVirtualContentId) {
      this.props.onCreate(
        VirtualContentStore.getVirtualContentById(newProps.newVirtualContentId)
      );
    }
  }

  render() {
    let { onRequestClose, eventBucket, film, isCreating } = this.props;

    return (
      <BaseOverlay
        onRequestClose={onRequestClose}
        useMuiDefaultStyle={true}
        actions={[
          <FlatButton label="Cancel" onTouchTap={onRequestClose} />,
          <FlatButton
            primary={true}
            disabled={
              isCreating || this.state.submitting || !this.state.permission
            }
            label={
              isCreating || this.state.submitting
                ? "Adding external virtual content..."
                : "Add external virtual content"
            }
            onTouchTap={this.submit}
          />
        ]}
      >
        <div>
          Please enter a complete external URL where the {film.name} content can
          be accessed.
        </div>
        <div style={{ marginTop: "1em" }}>
          <strong>
            DANGER: External content linked through this pop-up has NO content
            protection and may be downloaded by viewers. Only virtual content
            uploaded directly via Eventive Media is secured with MPAA-approved
            DRM protection.{" "}
            <span style={{ fontStyle: "italic" }}>Proceed with caution.</span>
          </strong>
        </div>
        <TextField
          floatingLabelText="External virtual content URL"
          floatingLabelFixed={true}
          value={this.state.url}
          style={{ width: 400 }}
          placeholder="https://example.com/my-video"
          type="url"
          onChange={e => this.setState({ url: e.target.value })}
          autoFocus
        />
        <Checkbox
          style={{ marginTop: "1em" }}
          value={this.state.permission}
          onCheck={(e, checked) => this.setState({ permission: checked })}
          label="I have permission from the content owner to distribute this content with no security in place. I understand that by choosing not to use Eventive Media, my content is not protected."
        />
      </BaseOverlay>
    );
  }
}

export default connectToStores(AddExternalVirtualContentOverlay);



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/add-external-virtual-content.jsx